import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import React, { useEffect, useState } from 'react';
import SubjectChip from './subject.chip';
import { subjectApi } from './subject.queries';

export default function SubjectAutocomplete(props) {
	const useGetAll = subjectApi.useGetAll();
	const subjects = useGetAll.data || [];

	const [open, setOpen] = useState(false);
	const [selected, setSelected] = useState([]);

	useEffect(() => {
		if (subjects.length && props?.defaultValue) {
			setSelected(subjects.filter((s) => props.defaultValue.includes(s.id)));
		}
	}, [subjects, props?.defaultValue]);

	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleChange = (e, newValue) => {
		setSelected(newValue);
		props?.onChange?.(newValue);
	};

	return (
		<Autocomplete
			multiple
			open={open}
			onOpen={handleOpen}
			onClose={handleClose}
			onChange={handleChange}
			getOptionLabel={(option) => option.name}
			getOptionKey={(option) => option.id}
			value={selected}
			options={subjects}
			loading={useGetAll.isPending}
			renderInput={(params) => (
				<TextField {...params} label="Filter Subjects..." slotProps={{
					input: {
						...params.InputProps,
						endAdornment: (
							<React.Fragment>
								{useGetAll.isPending ? <CircularProgress color="inherit" size={20} /> : null}
								{params.InputProps.endAdornment}
							</React.Fragment>
						),
					},
				}}
				/>
			)}
			renderOption={(props, option, { selected }) => {
				const { key, ...optionProps } = props;
				return (
					<li key={key} {...optionProps}>
						<SubjectChip subject={option} hideLink={true} />
					</li>)
			}}
		/>
	);
}